export default __webpack_public_path__ + "static/student-group-bafccc1e7e5595bc4e7fb662b8cda7bd.png";